module.exports = __webpack_public_path__ + "img/case-logo-22.71648ed0.png";